import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import MenuEditor from './pages/MenuEditor';
import PublicMenu from './pages/PublicMenu';
import PrivateRoute from './components/PrivateRoute';
import Staff from './pages/Staff';

// <Routes> 内に追加


function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          <Route path="/menu-editor" element={
            <PrivateRoute>
              <MenuEditor />
            </PrivateRoute>
          } />
          <Route path="/menu/:storeId" element={<PublicMenu />} />
          <Route path="/:storeId" element={<PublicMenu />} />
          <Route path="/:storeId/staff" element={<Staff />} />        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;